"use client";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { fetchLeadPreview } from "../state/services";
import { useStoreSelectors } from "../store";

export default function MaskedLeadInfo({ note }) {
  const { selectCurrentStep } = useStoreSelectors();
  const currentStep = selectCurrentStep();
  const [leadPreview, setLeadPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const textColor = currentStep.stepTextColor ?? "";

  useEffect(() => {
    setLoading(true);
    fetchLeadPreview()
      .then(setLeadPreview)
      .catch(() => setLeadPreview(null))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (leadPreview) {
      setLoading(false);
    }
  }, [leadPreview]);

  return (
    <div className={`masked-lead-info w-full flex flex-col items-center text-center gap-4 ${textColor}`}>
      {loading && <div className="masked-lead-info__loading mx-auto p-4">Loading...</div>}

      {!loading && leadPreview && (
        <div className="masked-lead-info__content">
          {leadPreview.name && <div className="masked-lead-info__name md:text-2xl font-semibold">{leadPreview.name}</div>}
          <div className="masked-lead-info__email md:text-2xl font-semibold">{leadPreview.email}</div>
          <div className="masked-lead-info__phone md:text-2xl font-semibold">{leadPreview.phone}</div>
        </div>
      )}

      {note && (
        <div
          className="masked-lead-info__note w-auto text-xs max-w-sm mx-auto pb-8 text-center"
          dangerouslySetInnerHTML={{ __html: note }}
        />
      )}
    </div>
  );
}

MaskedLeadInfo.propTypes = {
  note: PropTypes.string,
};




